import { userApi, loginApi } from '@/api'

let _getUserInfoInflight = null

const state = {
  token: localStorage.getItem('token') || '',
  userInfo: JSON.parse(localStorage.getItem('userInfo') || 'null'),
  bindMobileDialogOpen: false
}

const getters = {
  token: state => state.token,
  userInfo: state => state.userInfo,
  isLoggedIn: state => !!state.token,
  bindMobileDialogOpen: state => state.bindMobileDialogOpen
}

const mutations = {
  SET_TOKEN (state, token) {
    state.token = token
    if (token) {
      localStorage.setItem('token', token)
    } else {
      localStorage.removeItem('token')
    }
  },
  SET_USER_INFO (state, userInfo) {
    state.userInfo = userInfo
    if (userInfo) {
      localStorage.setItem('userInfo', JSON.stringify(userInfo))
    } else {
      localStorage.removeItem('userInfo')
    }
  },
  SET_BIND_MOBILE_DIALOG_OPEN (state, open) {
    state.bindMobileDialogOpen = !!open
  }
}

const actions = {
  // 登录
  async login ({ commit }, loginForm) {
    try {
      const res = await loginApi.loginByPassword(loginForm)
      commit('SET_TOKEN', res.data.token)
      commit('SET_USER_INFO', res.data.userInfo)
      return Promise.resolve(res)
    } catch (error) {
      return Promise.reject(error)
    }
  },

  // 获取用户信息
  async getUserInfo ({ commit, dispatch }, { force = false } = {}) {
    try {
      // 去重：避免启动/刷新、路由守卫、登录成功后并发触发多次请求
      if (_getUserInfoInflight) return _getUserInfoInflight

      _getUserInfoInflight = (async () => {
        const res = await userApi.getUserInfo()
        commit('SET_USER_INFO', res.data)
        await dispatch('maybePromptBindMobile', { mobile: res?.data?.mobile, force: true })
        return res
      })()

      return await _getUserInfoInflight
    } catch (error) {
      return Promise.reject(error)
    } finally {
      _getUserInfoInflight = null
    }
  },

  // 应用启动/刷新时：若已登录则刷新一次用户信息
  async refreshUserInfoIfLoggedIn ({ getters, dispatch }) {
    if (!getters.token) return
    return dispatch('getUserInfo', { force: true })
  },

  // mobile 为空时强制提示绑定手机号（必须绑定）
  maybePromptBindMobile ({ commit }, { mobile } = {}) {
    const m = (mobile ?? '').toString().trim()
    if (m) return
    commit('SET_BIND_MOBILE_DIALOG_OPEN', true)
  },

  openBindMobileDialog ({ dispatch }) {
    return dispatch('maybePromptBindMobile', { mobile: '' })
  },

  closeBindMobileDialog ({ commit }) {
    commit('SET_BIND_MOBILE_DIALOG_OPEN', false)
  },

  // 退出登录（直接清空本地信息，不调用接口）
  logout ({ commit }) {
    commit('SET_TOKEN', '')
    commit('SET_USER_INFO', null)
    commit('SET_BIND_MOBILE_DIALOG_OPEN', false)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
